import ApiInstance from "@/services/api/api.utils";
import { StorageKey } from "@/services/constants/global";
import { parseUserInformation } from "@/services/models/user";

export const getUserInfo = async () => {
  const res = await ApiInstance.get("/users/me");
  const convertedRes = parseUserInformation(res);
  const localToken = localStorage.getItem(StorageKey.xToken);
  if (localToken) {
    localStorage.setItem(StorageKey.userData, JSON.stringify(convertedRes));
    localStorage.setItem("scUserId", res._id);
  } else {
    sessionStorage.setItem(StorageKey.userData, JSON.stringify(convertedRes));
    sessionStorage.setItem("scUserId", res._id);
  }
  return parseUserInformation(res);
};

export const putDeleteUser = async (payload = {}) => {
  await ApiInstance.put("/users/delete", payload);
};
